export default "__VITE_ASSET__Dp6IrjZE__"